import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";

const apiClient = createApiClient("json");
const BASE_URL = "/api/vpn/apple_models";

const fetchListData = async () => {
  const { data = [] } = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  const dataWithId = data.map((record) => ({
    ...record,
    id: record.slug,
  }));

  return {
    data: dataWithId,
    total: data.length,
  };
};

export const appleModelsSchema: DataProviderSchema<"AppleModel", "json"> = {
  list: fetchListData,
};
